// extracted by mini-css-extract-plugin
export default {"a":"styles_a__hZpIQ","link_blue":"styles_link_blue__5hq+m"};